var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLabel = function SvgLabel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m16.842 8.651-7.5-7.5c-.3-.3-.717-.483-1.175-.483H2.334c-.917 0-1.667.75-1.667 1.667v5.833c0 .458.183.875.492 1.183l7.5 7.5c.3.3.716.484 1.175.484a1.63 1.63 0 0 0 1.175-.492l5.833-5.833c.308-.3.492-.717.492-1.175s-.192-.884-.492-1.184m-7.008 7.025-7.5-7.508V2.335h5.833v-.009l7.5 7.5z"
  })));
};
export { SvgLabel as ReactComponent };